<template>
    <div class="structure-box">
        <div class="title-box">
            <HeaderNav
                header-title="产品流向"
                left-icon-name="2"
                right-icon-name="3"
            ></HeaderNav>
            <div @click="showPickerTime = true" class="title-tips">
                <span class="iconfont iconrili"></span>
                <p>{{ selectTimeYear }}年{{ selectTimeMonth }}月份，中国联合水泥商混业务产销概况</p>
            </div>
        </div>
        <div
            class="picker-content"
            v-show="showPickerTime"
        >
            <van-datetime-picker
                v-model="currentDate"
                :max-date="maxDate"
                type="year-month"
                @confirm="selectTime"
                @cancel="showPickerTime = false"
            ></van-datetime-picker>
        </div>
        <div class="structure-box-content">
            <!-- 图表1 -->
            <div class="main-box">
                <div id="main"></div>
                <span>单位(万方)</span>
            </div>
            <div class="zhanwei"></div>
            <!-- 图表2 -->
            <div id="mainOne"></div>
        </div>
    </div>
</template>
<script>
import { HeaderNav } from '@/components/';
import { Dialog } from 'vant';
import utils from '@/assets/js/utils';
export default {
    components: {
        HeaderNav,
    },
    data() {
        return {
            chartsTypeName: [],
            chartsPrice: [],
            chartsSales: [],
            chartsSalesRate: [],
            originChart: [],
            currentDate: new Date(),
            maxDate: '',
            selectTimeYear: '',
            selectTimeMonth: '',
            orgId: '',
            showPickerTime: false,
        };
    },
    created() {
        const obj = utils.getPreMon();
        this.maxDate = new Date(obj.year, obj.month - 1, obj.lastDate);
    },
    mounted() {
        this.selectTimeYear = this.$route.query.year;
        this.selectTimeMonth = this.$route.query.month;
        const value = this.$store.state.orgData[0].value;
        this.orgId = value;
        this.getFlowtoStruct();
        this.getFlowtoStructTwo();
    },
    methods: {
        // 时间选择
        selectTime(value) {
            this.selectTimeYear = utils.timeFormat(value, 'year');
            this.selectTimeMonth = utils.timeFormat(value, 'month');
            this.showPickerTime = false;
            this.getFlowtoStruct();
            this.getFlowtoStructTwo();
        },
        //  本月商砼结构
        getFlowtoStruct() {
            this.chartsTypeName = [];
            this.chartsSales = [];
            this.chartsSalesRate = [];
            this.chartsPrice = [];
            this.originChart = [];
            this.$axios
                .get(`/interfaceApi/report/FlowToManager/get_flowto_struct/${this.selectTimeYear}/${this.selectTimeMonth}/${this.orgId}`)
                // .get(`/interfaceApi/report/FlowToManager/get_flowto_struct/2019/3/${this.orgId}`)
                .then(res => {
                    if (res) {
                        const arr = res;
                        arr.sort(function (a, b) {
                            return a.type_code - b.type_code;
                        });
                        let count = 0;
                        res.forEach(item => {
                            if (item.sales === 0) {
                                count++;
                            }
                        });

                        if (count === res.length) {
                            this.originChart = res.map(item => {
                                return {
                                    value: 0,
                                    name: item.type_name,
                                };
                            });
                        } else {
                            res.forEach(items => {
                                let obj = {};
                                let arr;
                                if (items.sales) {
                                    arr = Number(items.sales.toFixed(2));
                                } else {
                                    arr = 0;
                                }
                                if (arr !== 0) {
                                    obj = {
                                        value: arr,
                                        name: items.type_name,
                                    };
                                    this.originChart.push(obj);
                                }
                            });
                        }
                        this.drawPieChart();
                    }
                })
                .catch(error => {
                    Dialog({ message: error.Errorcode.Message });
                });
        },
        toFixedFunction(item) {
            if (item) {
                return item.toFixed(2);
            }
            return 0;
        },
        // 全年累计商砼
        getFlowtoStructTwo() {
            this.chartsTypeName = [];
            this.chartsSales = [];
            this.chartsSalesRate = [];
            this.chartsPrice = [];
            this.originChart = [];
            this.$axios
                .get(`/interfaceApi/report/FlowToManager/get_flowto_struct_year/${this.selectTimeYear}/${this.selectTimeMonth}/${this.orgId}`)
                // .get('/interfaceApi/report/FlowToManager/get_flowto_struct_year/2019/OT000001')
                .then(res => {
                    if (res) {
                        const arr = res;
                        arr.sort(function (a, b) {
                            return a.type_code - b.type_code;
                        });
                        arr.forEach(item => {
                            const brr = this.toFixedFunction(item.sales);
                            const shoujia = this.toFixedFunction(item.price);
                            this.chartsTypeName.push(item.type_name);
                            this.chartsSales.push(brr || 0);
                            this.chartsPrice.push(shoujia);
                            this.chartsSalesRate.push(item.sales_rate);
                        });
                        this.chartsTwo();
                    }
                })
                .catch(() => {
                });
        },
        drawPieChart() {
            const rich = {
                valueColor: {
                    color: '#333',
                    align: 'center',
                },
                nameColor: {
                    align: 'center',
                },
                hr: {
                    height: 6,
                },
            };
            const data = this.originChart;
            // 基于准备好的dom，初始化echarts实例
            const myCharts = this.$echarts.init(document.getElementById('main'));
            // 指定图表的配置项和数据
            const option = {
                title: {
                    x: 'left',
                    text: '本月商砼销项结构分析',
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)',
                },
                series: [
                    {
                        name: ' ',
                        type: 'pie',
                        radius: '45%',
                        center: ['50%', '60%'],
                        color: ['#023353', '#03496a', '#006382', '#0682a6', '#339abd', '#5ab4d9', '#70caed', '#8eddfb', '#bdecff', '#d7f2fd'],
                        itemStyle: {
                            borderWidth: 5,
                            borderColor: '#FFFFFF',
                        },
                        data: data,
                        label: {
                            normal: {
                                textStyle: {
                                    fontSize: 12,
                                },
                                formatter: function (params) {
                                    let total = 0;
                                    let percent = 0;
                                    data.forEach( function (value) {
                                        total += value.value;
                                    });
                                    percent = !isNaN(( params.value / total * 100).toFixed(2)) ? ( params.value / total * 100).toFixed(2) : 0;
                                    return '{nameColor|' + params.name + '(' + percent + '%)}\n{hr|}\n{valueColor|' + params.value + '}';
                                },
                                rich: rich,
                            },
                        },
                    },
                ],
            };
            // 使用刚指定的配置项和数据显示图表。
            myCharts.setOption(option, true);
        },
        chartsTwo() {
            const myChart = this.$echarts.init(document.getElementById('mainOne'));
            // 指定图表的配置项和数据
            const option = {
                title: {
                    x: 'left',
                    text: '本年累计商砼销项结构分析',
                    paddingBottom: 20,
                },
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    padding: 30,
                    data: ['销量', '售价'],
                    itemWidth: 20, // 图例图形宽度
                    itemHeight: 10,
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.chartsTypeName,
                        axisPointer: {
                            type: 'shadow',
                        },
                        // 设置间隔
                        axisLabel: {
                            interval: 0,
                            fontSize: 10, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        boundaryGap: true,
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '销量(万方)',
                        axisLabel: {
                            formatter: '{value}',
                            fontSize: 10, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                    {
                        type: 'value',
                        name: '售价(元/方)',
                        axisLabel: {
                            fontSize: 10, // 字体大小
                            formatter: '{value}',
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                ],
                series: [
                    {
                        name: '销量',
                        type: 'bar',
                        data: this.chartsSales,
                        color: '#5588F1',
                        barWidth: 10, // 柱图宽度
                    },
                    {
                        name: '售价',
                        type: 'line',
                        yAxisIndex: 1,
                        data: this.chartsPrice,
                        color: '#FA8436',
                    },
                ],
            };
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option, true);
        },
    },
};
</script>

<style lang="stylus" scope>
.title-box
    position fixed
    top 0
    left 0
    right 0
    z-index 99
.main-box
    position relative
    span
        position absolute
        font-size: 10rpx;
        font-weight:400;
        color:rgba(151,158,167,1);
        top 10rpx
        right 20rpx
        z-index 7
.structure-box-content
    overflow-y scroll
    padding-top 74rpx
    padding-bottom 4rpx
    height 100%
.zhanwei
    width 100%
    height 15rpx
    background #F0F0F0
.title-one
    padding 15rpx 5% 10rpx
#main
    width 90%
    height 300rpx
    margin 15rpx 5% 0
#mainOne
    width 90%
    height 300rpx
    margin 15rpx 5% 20rpx

.picker-content
    position fixed
    width: 100%;
    z-index 9
    height: 100%;
    background: rgba(0, 0, 0, .4);
    top: 0
    z-index 999
    .van-picker
        position: fixed;
        bottom: 0;
        width: 100%;
.title-tips
    width 100%
    height 30rpx
    font-size 12rpx
    color #333333
    display flex
    justify-content center
    align-items center
    background #F0F0F0
    margin-top 44rpx
    .iconrili
        font-size 18rpx
        margin-right 6rpx
        cursor pointer
        color: #5588F1;
</style>